<template>
  <div>
    <v-dialog
      v-model="dialogSit"
      transition="dialog-bottom-transition"
      max-width="800"
      persistent
    >
      <v-card>
        <v-toolbar>
          <v-btn icon @click="closeSit">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ dialogTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <template v-if="editSit == true">
            <v-btn @click="saveSit">
              <v-icon left>save</v-icon>Записать изменения
            </v-btn>
          </template>
          <template v-else-if="editSit == false">
            <v-btn @click="saveSitAdd">
              <v-icon left>save</v-icon>Создать
            </v-btn>
          </template>
        </v-toolbar>
        <v-card-text>
          <v-form v-model="validSitAdd" ref="addedItemSit" lazy-validation>
            <template v-if="editSit == false">
              <v-select
                v-model="addedItemSit.sit_id"
                :items="situations"
                label="Ситуация у клиента"
                item-text="name"
                item-value="id"
              ></v-select>
            </template>
            <template v-else-if="editSit == true">
              <v-select
                v-model="addedItemSit.sit_id"
                :items="situations"
                label="Ситуация у клиента"
                item-text="name"
                item-value="id"
                readonly
              ></v-select>
            </template>

            <v-textarea
              v-model="addedItemSit.note"
              label="Ситуация у клиента (примечание):"
            ></v-textarea>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-data-table
      dense
      :headers="headers"
      :items="desserts"
      :search="search"
      sort-by="id"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <!-- <v-toolbar-title>Ситуации у клиента</v-toolbar-title> -->
          <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
          <!-- <v-spacer></v-spacer> -->
          <v-text-field
            v-model="search"
            append-icon="search"
            clearable
            label="Поиск ..."
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn class="mb-2" @click="AddSit"
            ><v-icon left>add</v-icon>Добавить ситуацию у клиента</v-btn
          >
        </v-toolbar>
      </template>

      <template v-slot:item.sit_id="{ item }">
        {{ getYourSit(item.sit_id) }}
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="editSitt(item)"> edit </v-icon>
        <v-icon small @click="deleteSit(item)"> delete </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  data: () => ({
    validSitAdd: true,
    addedItemSit: {},
    editSit: false,
    editSituation: false,
    search: "",
    dialogTitle: "",
    dialog: false,
    dialogSit: false,
    headers: [
      {
        text: "Ситуация у клиента",
        align: "left",
        sortable: true,
        value: "sit_id",
      },
      {
        text: "Описание",
        align: "left",
        sortable: true,
        value: "note",
      },
      { text: "Действия", align: "center", value: "action", sortable: false },
    ],
    //desserts: [],
  }),

  computed: {
    desserts() {
      return this.$store.getters.getSituationsWithCommentCS;
    },
    situations() {
      return this.$store.getters.getSituationsCS;
    },
  },

  created() {
    //this.initialize()
  },

  methods: {
    getBool(val) {
      if (val) return "Да";
      else return "Нет";
    },
    getColor(color) {
      if (color) return "red";
      return "transparent";
    },

    Add() {
      this.$store
        .dispatch("addSituationCS")
        .then(() => {
          this.$router.push({ name: "addsituation" });
        })
        .catch((error) => {
          alert(error);
        });
    },

    editItem(item) {
      const Arr = {
        id: item.id,
        name: item.name,
        active: item.active,
      };
      this.$store
        .dispatch("getSituationCS", Arr)
        .then(() => {
          this.$router.push({ name: "editsituation" });
        })
        .catch((error) => {
          alert(error);
        });
    },

    getYourSit(id) {
      return this.$store.getters.getSituationsCS.filter(
        (item) => item.id === id
      )[0].name;
    },

    editSitt(item) {
      this.addedItemSit.sit_id = item.sit_id;
      this.addedItemSit.note = item.note;
      this.editSit = true;
      this.editSituation = true;
      this.dialogTitle = "Изменение комментария ситуации";
      this.dialogSit = true;
    },
    AddSit() {
      this.addedItemSit.note = "";
      this.addedItemSit.sit_id = null;
      this.editSituation = false;
      this.editSit = false;
      this.dialogTitle = "Добавление комментария ситуации";
      this.dialogSit = true;
    },
    closeSit() {
      this.dialogSit = false;
    },
    saveSitAdd() {
      if (!this.addedItemSit.sit_id) {
        Swal.fire({
          icon: "error",
          title: "Не заполнена ситуация",
          text: "Заполните как минимум ситуацию у клиента",
        });
        return;
      }
      this.dialogSit = false;

      var formArr = Object.assign({}, this.addedItemSit);
      const payload = {
        id: this.$store.getters.getProductCS.id,
        formData: formArr,
      };
      this.$store
        .dispatch("addSituationComment", payload)
        .then((response) => {
          Swal.fire({
            icon: "success",
            title: "OK!",
            text: "Данные успешно Добавились",
          });
          this.$store.commit(
            "SET_CURRENT_SITUATIONSCS",
            response.data.situations
          );
        })
        .catch(() => {
          //
          Swal.fire({
            icon: "error",
            title: "Данные не сохранились",
            text: "Не удалось добавить новую ситуацию с комментарием",
          });
        });
    },
    saveSit() {
      if (!this.addedItemSit.sit_id) {
        return;
      }
      this.dialogSit = false;
      var formArr = Object.assign({}, this.addedItemSit);
      const payload = {
        id: this.$store.getters.getProductCS.id,
        formData: formArr,
      };
      this.$store
        .dispatch("editSituationComment", payload)
        .then((response) => {
          Swal.fire({
            icon: "success",
            title: "OK!",
            text: "Данные успешно сохранились",
          });
          this.$store.commit(
            "SET_CURRENT_SITUATIONSCS",
            response.data.situations
          );
        })
        .catch(() => {
          //
          Swal.fire({
            icon: "error",
            title: "Данные не сохранились",
            text:
              "Не удалось сохранить расшифровку ситуации банковского продукта",
          });
        });
    },

    deleteSit(item) {
      var formArr = Object.assign({}, item);

      this.$store
        .dispatch("deleteSituationComment", formArr)
        .then((response) => {
          //
          this.$store.commit(
            "SET_CURRENT_SITUATIONSCS",
            response.data.situations
          );
          Swal.fire({
            icon: "success",
            title: "Данные удалились",
            text: "Комментарий к ситуации удачно удален",
          });
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Данные не удалились",
            text: "Комментарий к ситуации удачно не удален",
          });
        });
    },
  },
};
</script>
